import React from 'react';
import { Car } from 'lucide-react';

interface Props {
    /** true = auto aziendale, false = auto privata */
    value: boolean;
    onChange: (autoAziendale: boolean) => void;
    /** xs per le card compatte (approvazioni, report), sm per i form */
    size?: 'xs' | 'sm';
    /** pulsanti uno sotto l'altro, per le caselle strette dove affiancati verrebbero troncati */
    verticale?: boolean;
    disabled?: boolean;
    className?: string;
}

/**
 * Scelta del veicolo: due pulsanti "Auto aziendale" / "Auto privata", sempre uno solo attivo.
 */
const AutoAziendaleSelector: React.FC<Props> = ({ value, onChange, size = 'sm', verticale = false, disabled = false, className = '' }) => {
    const txt = size === 'xs' ? 'text-[8px] px-1 py-1 gap-0.5'
        : verticale ? 'text-[9px] px-1.5 py-1.5 gap-1' : 'text-[10px] px-2 py-2 gap-1';
    const icon = size === 'xs' ? 8 : verticale ? 10 : 11;
    const opzioni: { val: boolean; label: string; on: string }[] = [
        { val: true, label: 'Auto aziendale', on: 'bg-blue-50 text-blue-700 border-blue-300' },
        { val: false, label: 'Auto privata', on: 'bg-slate-100 text-slate-800 border-slate-400' },
    ];
    return (
        <div className={`grid ${verticale ? 'grid-cols-1' : 'grid-cols-2'} gap-1 ${className}`} role="radiogroup" aria-label="Veicolo">
            {opzioni.map(o => {
                const attivo = value === o.val;
                return (
                    <button
                        key={o.label}
                        type="button"
                        role="radio"
                        aria-checked={attivo}
                        disabled={disabled}
                        onClick={() => { if (!attivo) onChange(o.val); }}
                        className={`flex items-center justify-center rounded border font-bold uppercase transition-colors ${txt} ${
                            attivo ? o.on : 'bg-white text-slate-400 border-slate-200 hover:bg-slate-50'
                        } ${disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
                    >
                        <Car size={icon} className="shrink-0" />
                        <span className="truncate">{o.label}</span>
                    </button>
                );
            })}
        </div>
    );
};

export default AutoAziendaleSelector;
